module.exports = "./img/ae6926a3e5b3817ecd65691836787916.jpg";